import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Fade from "react-reveal/Fade";
import { useAuth } from "../../context/AuthContext";
import HelpDrawer from "./HelpDrawer";
import { useTranslation } from "react-i18next";
import Pagination from "@mui/material/Pagination";

import {
  db,
  collection,
  doc,
  query,
  where,
  getDocs,
  getDoc,
} from "../../firebase";
import OrdersPartial_KO from "./OrdersPartial_KO";
import { TextField } from "@mui/material";
import LeftMenu from "./LeftMenu";

const useStyles = makeStyles({
  body: {
    backgroundColor: "white",
    minHeight: "500px",
    padding: "50px",
  },
  title: {
    fontSize: "30px",
  },
});

const Dashboard = () => {
  let currentLocation = JSON.parse(
    window.sessionStorage.getItem("iplookup")
  ).countryCode;
  currentLocation = "KO";

  const [page, setPage] = React.useState(1);
  const handleChange = (event, value) => {
    setPage(value);
    console.log(value);
    window.scrollTo(0, 0);
  };
  const { t, i18n } = useTranslation();
  const numOfReviews = 5;
  const { currentUser } = useAuth();
  const classes = useStyles();
  const [orders, setOrders] = useState([]);

  const [option, setOption] = React.useState("");
  const [ordersToShow, setOrdersToShow] = useState([]);

  const [searchName, setSearchName] = useState(null);
  const [user, setUser] = useState(null);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      search(event);
    }
  };

  const search = (event) => {
    event.preventDefault();

    setOrdersToShow([]);
    let newList = [];
    orders.map((order) => {
      let tempBasket = JSON.parse(order.basket);
      let breakCondition = false;
      // console.log("tempBasket", tempBasket);
      tempBasket.map((temp) => {
        if (
          temp.name.toLowerCase().includes(searchName.toLowerCase()) &&
          !breakCondition
        ) {
          newList.push(order);
          breakCondition = true;
        }
      });
    });

    orders.map((order) => {
      if (order.id.replaceAll("-", "") === searchName.replaceAll("-", "")) {
        newList.push(order);
      }
    });
    setOrdersToShow(newList);
  };

  const sortByTime = (event = null) => {
    let newList = [];
    if (event) {
      setOption(event.target.value);

      // sort for only this year
      if (event.target.value === "This year") {
        orders.map((order) => {
          if (
            order.created.toDate().getFullYear() === new Date().getFullYear()
          ) {
            newList.push(order);
          }
        });
      } else if (event.target.value === "This month") {
        // sort for only this month
        orders.map((order) => {
          if (order.created.toDate().getMonth() === new Date().getMonth()) {
            newList.push(order);
          }
        });
      } else {
        newList = orders;
      }
    } else {
      newList = orders;
    }
    setOrdersToShow(newList);
  };

  useEffect(() => {
    sortByTime();
  }, [orders]);

  useEffect(() => {
    setOrders([]);
    const getOrders = async () => {
      let ref = await collection(db, "KO_orders");

      const q = query(ref, where("user_uid", "==", currentUser.uid));
      const querySnapshot = await getDocs(q);
      let list = [];
      querySnapshot.forEach((doc) => {
        // console.log(doc.id, " => ", doc.data());
        if (doc.data().basket) {
          // console.log(JSON.parse(doc.data().basket));
        }
        list = list.concat({ ...doc.data(), id: doc.id });
      });

      let newlist = list.sort((a, b) => b.created - a.created);

      setOrders(newlist);
    };
    getOrders();

    setUser(null);
    const getUser = async () => {
      const docRef = doc(db, "users", currentUser.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setUser(docSnap.data());
      }
    };
    getUser();

    return () => {
      setOrders(null);
      setUser(null);
    };
  }, []);

  return (
    <Grid
      container
      sx={{
        px: { md: 10, sm: 5 },
        pt: 7,
        pb: 20,
        backgroundColor: "#eceff1",
      }}
    >
      <Grid item sm={12} md={12} sx={{ fontSize: "19px", pb: 2, pl: 2 }}>
        <Box>{t("MY ACCOUNT")}</Box>
      </Grid>

      <LeftMenu cursor="dashboard" />
      <Grid item md={9} sm={12} className={classes.body}>
        <Box
          sx={{
            width: 1,
            display: "flex",
            justifyContent: "space-between",
            // border: "1px solid black",
          }}
        >
          <Box sx={{ fontWeight: 600, fontSize: "17px" }}>
            <Fade delay={300}>{t("Orders")}</Fade>
          </Box>

          <Box
            sx={{
              position: "relative",
              top: "-10px",
              border: "1px solid lightgray",
              borderRadius: "20px",
            }}
          >
            <HelpDrawer />
          </Box>
        </Box>
        <Box
          className="textBox"
          sx={{
            my: 1,
            fontSize: "13px",
          }}
        >
          {t(
            "During this national emergency, COVID-19 pandemic might cause delays in delivery of some mail, packages."
          )}
        </Box>
        <Box
          sx={{
            pb: 2,
            pt: 1,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <FormControl sx={{}}>
            <InputLabel id="demo-simple-select-label">
              {t("Sort By Time")}
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={option}
              label="Select"
              onChange={(e) => sortByTime(e)}
              sx={{ width: 200 }}
            >
              <MenuItem value="all" selected>
                {t("Show All")}
              </MenuItem>
              <MenuItem value="This year">{t("This Year")}</MenuItem>
              <MenuItem value="This month">{t("This Month")}</MenuItem>
            </Select>
          </FormControl>
          <Box>
            <TextField
              variant="filled"
              label={t("Search a name of product or Order #")}
              sx={{ width: 285 }}
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
            />
            <button
              onClick={search}
              onKeyDown={(e) => handleKeyPress(e)}
              className="custom_btn"
              style={{ width: 100, paddingTop: "18px", paddingBottom: "18px" }}
            >
              {t("Submit")}
            </button>
          </Box>
        </Box>
        <Box>
          <OrdersPartial_KO
            block={user?.block}
            orders={ordersToShow.slice(
              (page - 1) * numOfReviews,
              numOfReviews * page
            )}
          />
        </Box>

        <Pagination
          count={Math.ceil(orders.length / numOfReviews)}
          variant="outlined"
          color="secondary"
          sx={{ my: 2 }}
          onChange={handleChange}
          page={page}
        />
      </Grid>
    </Grid>
  );
};

export default Dashboard;
